import { render, staticRenderFns } from "./AddMorePlansButton.vue?vue&type=template&id=391040f4"
import script from "./AddMorePlansButton.vue?vue&type=script&lang=js"
export * from "./AddMorePlansButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports